import React, { useState } from 'react';
import { Play, X } from 'lucide-react';
import { useSiteData } from '../context/SiteDataContext';

const Media = () => {
  const { sermons } = useSiteData();
  const [current, setCurrent] = useState(null);

  return (
    <div className="bg-blue-950 text-white" data-testid="media-page">
      <section className="pt-16 pb-10 px-6 lg:px-10 text-center">
        <div className="text-xs tracking-[0.3em] text-white/60 mb-3">MEDIA</div>
        <h1 className="hero-title text-4xl md:text-6xl">Timeless Messages</h1>
        <p className="mt-5 text-white/75 max-w-[760px] mx-auto">
          No matter where you are, we invite you to worship, praise, sing, and pray along with us. God’s presence and power are not limited to a building or a moment in time. As you watch our services, may the Lord speak to your heart, strengthen your faith, and minister to you richly.
        </p>
      </section>

      <section className="py-16 px-6 lg:px-10">
        <div className="max-w-[1300px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {sermons.map((s) => (
            <button
              key={s.id}
              onClick={() => setCurrent(s)}
              className="group text-left card-hover"
              data-testid={`sermon-${s.id}`}
            >
              <div className="relative aspect-video overflow-hidden bg-neutral-900">
                <img
                  src={`https://i.ytimg.com/vi/${s.youtube_id}/hqdefault.jpg`}
                  alt={s.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-blue-950/30 group-hover:bg-blue-950/10 transition-colors" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-white/90 text-black flex items-center justify-center group-hover:scale-110 transition-transform">
                    <Play size={22} fill="#000" />
                  </div>
                </div>
                {s.duration && <div className="absolute bottom-2 right-2 bg-blue-950/80 text-white text-xs px-2 py-1">{s.duration}</div>}
              </div>
              <div className="pt-4">
                <h3 className="serif-display text-lg font-semibold">{s.title}</h3>
                <p className="text-white/60 text-sm mt-1">{s.speaker}</p>
              </div>
            </button>
          ))}
        </div>
      </section>

      {/* Video modal */}
      {current && (
        <div className="fixed inset-0 z-[100] bg-blue-950/90 flex items-center justify-center px-4 py-6" onClick={() => setCurrent(null)} data-testid="sermon-modal">
          <div className="relative w-full max-w-5xl" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setCurrent(null)}
              className="absolute -top-12 right-0 text-white hover:text-white/70 flex items-center gap-2 text-sm tracking-[0.2em]"
            >
              CLOSE <X size={18} />
            </button>
            <div className="aspect-video w-full bg-blue-950">
              <iframe
                src={`https://www.youtube.com/embed/${current.youtube_id}?autoplay=1`}
                title={current.title}
                className="w-full h-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div className="mt-4 text-white">
              <h3 className="serif-display text-2xl font-semibold">{current.title}</h3>
              <p className="text-white/60 mt-1">{current.speaker}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Media;
